import JournalLpo from "@/components/JournalLpo";
import CreateLpo from "@/components/CreateLpo";
import LpoData from "@/components/LpoData";

import GroupLpoListWithExisting from "@/components/LpoData/GroupLpoListWithExisting";

import TaxInfo from "@/components/TaxInfo";

/* Выбранное обследование (CurrentLpo) и вкладки для него */
import CurrentLpo from "@/components/LpoData/LpoData__current";
import CurrentLpoSection from "@/components/LpoData/LpoData__current/CurrentLpo__section";
import CurrentLpoGeometry from "@/components/LpoData/LpoData__current/CurrentLpo__geometry";
import CurrentLpoInspection from "@/components/LpoData/LpoData__current/CurrentLpo__inspection";
import CurrentLpoResult from "@/components/LpoData/LpoData__current/CurrentLpo__result";

/* Акт (общая информация для всех обследований в группе) и вкладки для него */
import ActLpo from "@/components/LpoData/LpoData__act";
import ActLpoList from "@/components/LpoData/LpoData__act/Act__lpoList";
import ActLpoLease from "@/components/LpoData/LpoData__act/Act__lease";
import ActLpoGeometry from "@/components/LpoData/LpoData__act/Act__geometry";
import ActLpoUploads from "@/components/LpoData/LpoData__act/Act__uploads";

import LoginComponent from "@/components/LoginComponent";
import RegisterComponent from "@/components/RegisterComponent";
import ImportXmlComponent from "@/components/ImportXmlComponent";
import BlockUserComponent from "@/components/BlockUserComponent";
import MainView from "@/views/MainView";
import VideoTutorial from "@/components/VideoTutorial";

const routes = [
  {
    path: "/",
    name: "main",
    component: MainView,
    redirect: "/journal-lpo",
    meta: { requiresAuth: true },
    children: [
      { path: "journal-lpo", name: "journal-lpo", component: JournalLpo },
      { path: "create-lpo", name: "create-lpo", component: CreateLpo },
      { path: "tax-info", name: "tax-info", component: TaxInfo },

      // {
      //   name: 'act',
      //   path: 'act/:act_id',
      //   component: ActLpo1,

      //   children: [
      //     {
      //       name: 'lpo',
      //       path: 'lpo/:lpo_id',
      //       // redirect: { name: 'act-lpo-list' },
      //       component: CurrentLpo1,

      //       children: [
      //         { path: 'lpo-list', name: 'act-lpo-list', component: ActLpoList },
      //         { path: 'lease', name: 'lease', component: ActLpoLease },
      //         { path: 'geometry', name: 'geometry', component: ActLpoGeometry },
      //         { path: 'grouping-with-existing', name: 'grouping-with-existing', component: GroupLpoListWithExisting, props: true },
      //         { path: 'uploads', name: 'upload-materials', component: ActLpoUploads },
      //       ]
      //     }
      //   ]
      // },

      {
        path: "lpo/:lpo_id",
        name: "lpo",
        component: LpoData,
        redirect: { name: "current-lpo" },
        children: [
          {
            name: "act",
            path: "act",
            redirect: { name: "act-lpo-list" },
            component: ActLpo,
            children: [
              { path: "lpo-list", name: "act-lpo-list", component: ActLpoList },
              { path: "lease", name: "lease", component: ActLpoLease },
              { path: "geometry", name: "geometry", component: ActLpoGeometry },
              {
                path: "grouping-with-existing",
                name: "grouping-with-existing",
                component: GroupLpoListWithExisting,
                props: true,
              },
              {
                path: "uploads",
                name: "upload-materials",
                component: ActLpoUploads,
              },
            ],
          },

          {
            name: "current-lpo",
            path: "current",
            redirect: { name: "current-lpo-section" },
            component: CurrentLpo,
            children: [
              {
                path: "section",
                name: "current-lpo-section",
                component: CurrentLpoSection,
              },
              {
                path: "geometry",
                name: "current-lpo-geometry",
                component: CurrentLpoGeometry,
              },
              {
                path: "inspection",
                name: "current-lpo-inspection",
                component: CurrentLpoInspection,
              },
              {
                path: "result",
                name: "current-lpo-result",
                component: CurrentLpoResult,
              },
            ],
          },
        ],
      },
    ],
  },
  { name: "login", path: "/login", component: LoginComponent },
  { name: "register", path: "/register", component: RegisterComponent },
  { name: "removeuser", path: "/removeuser", component: BlockUserComponent },
  { name: "importxml", path: "/importxml", component: ImportXmlComponent },
  { name: "videotutorial", path: "/videotutorial", component: VideoTutorial }
];

export default routes;
